/**
 * The `?tab=` reader every record detail route shares.
 *
 * ── ITS OWN MODULE, WITH NO IMPORTS, AND THAT IS THE WHOLE POINT ──────────────────────────────
 *
 * The same bundle decision `deliverySearch.ts` records. `validateSearch` runs during ROUTING, so
 * it is one of the few things `autoCodeSplitting` cannot lift out of a route file — anything it
 * reaches lands in the eager bundle on every page of the app. Living beside `RecordTabs` would
 * have dragged `Link`, `Icon` and `cn` in behind it for the sake of one comparison.
 *
 * ── IN THE URL RATHER THAN IN COMPONENT STATE ─────────────────────────────────────────────────
 *
 * Every one of this tab's real entry paths is a URL: a manager pasting "the Beauchamps' documents"
 * to a colleague, a reload after fixing a contact's email, and the browser Back button after
 * opening a filed document. Component state survives none of the three.
 *
 * Anything unrecognised falls back to the overview rather than erroring. A mistyped `?tab=` is not
 * a broken record, and a page that refuses to render is a worse answer than one that opens where
 * it always does.
 *
 * `'invoices'` IS THE TENANCY'S, the way `'bond'` is — what the tenant has been charged that is
 * not rent. There is no property-level one: a bill is what the HOUSE cost and an invoice is what
 * the people in it owe, and the two are already separate tabs for that reason.
 *
 * `'images'` IS RECOGNISED FOR ALL FOUR ROUTES, though only `/properties/$ref` renders it — see
 * `RecordTabs`'s `images` prop. Refusing it here for the other three would not protect anything
 * (they simply never link to it), and would make this function know something about which record
 * types have photographs, which is a property of the tab, not of the URL. `'bond'` is the same
 * shape, for `/tenancies/$ref` — see `RecordTabs`'s `bond` prop, and so are `'maintenance'`,
 * `'bills'`, `'inspections'`, `'healthy-homes'` and `'timeline'`, for `/properties/$ref`.
 *
 * `'healthy-homes'` IS HYPHENATED, unlike every other value here, because it is what the operator
 * sees in the address bar and `healthyhomes` reads as a typo. The React prop and the component are
 * camel-cased as usual; the URL is the one place this record's name is written for a person.
 */
export function readTabSearch(search: Record<string, unknown>): {
  tab?:
    | 'documents'
    | 'images'
    | 'compliance'
    | 'healthy-homes'
    | 'bond'
    | 'maintenance'
    | 'bills'
    | 'invoices'
    | 'inspections'
    | 'listing'
    | 'timeline'
    | 'portal'
    | 'communications';
} {
  if (search.tab === 'documents') return { tab: 'documents' };
  if (search.tab === 'images') return { tab: 'images' };
  if (search.tab === 'compliance') return { tab: 'compliance' };
  if (search.tab === 'healthy-homes') return { tab: 'healthy-homes' };
  if (search.tab === 'bond') return { tab: 'bond' };
  if (search.tab === 'maintenance') return { tab: 'maintenance' };
  if (search.tab === 'bills') return { tab: 'bills' };
  if (search.tab === 'invoices') return { tab: 'invoices' };
  if (search.tab === 'inspections') return { tab: 'inspections' };
  if (search.tab === 'listing') return { tab: 'listing' };
  if (search.tab === 'timeline') return { tab: 'timeline' };
  // A person's, for `/people/$ref` — see `RecordTabs`'s `portal` prop.
  if (search.tab === 'portal') return { tab: 'portal' };
  // Every record type's — the email sent about it and what came back. See `RecordTabs`.
  if (search.tab === 'communications') return { tab: 'communications' };
  return {};
}
